import PropTypes from 'prop-types';

import Balloon from '../../../assets/balloon.svg';
import styles from './styles.module.css';

function KitoBalloon({ children, textVariant, outline, backgroundColor, ...rest }) {
  const background = {
    backgroundImage: `url(${Balloon})`,
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
  };
  const outlineStyle = {
    backgroundColor: outline,
    maskImage: `url(${Balloon})`,
    maskSize: '100% 100%',
    maskRepeat: 'no-repeat',
    WebkitMaskImage: `url(${Balloon})`,
    WebkitMaskSize: '100% 100%',
    WebkitMaskRepeat: 'no-repeat',
    position: 'absolute',
    inset: 0,
    zIndex: 0,
  };
  return (
    <p
      className={styles.kitoBalloon}
      style={{
        ...(outline ? { position: 'relative' } : background),
        ...(backgroundColor ? { backgroundColor } : {}),
      }}
      data-text-variant={textVariant}
      {...rest}
    >
      {outline && <span aria-hidden="true" style={outlineStyle} />}
      <span style={outline ? { position: 'relative', zIndex: 1 } : backgroundColor ? { backgroundColor } : undefined}>
        {children}
      </span>
    </p>
  );
}

KitoBalloon.propTypes = {
  children: PropTypes.node.isRequired,
  textVariant: PropTypes.oneOf(["title", "error", "warning"]),
  outline: PropTypes.string,
  backgroundColor: PropTypes.string,
  rest: PropTypes.object
}

export default KitoBalloon;